export type FxBreaklineType = 'curbAndGutter' | 'roadCrown' | 'jerseyBarrier';

export const FX_BREAKLINE_TYPES: readonly FxBreaklineType[] = [
  'curbAndGutter',
  'roadCrown',
  'jerseyBarrier',
];

export interface FxBreakline {
  readonly type: FxBreaklineType;
  readonly name: string;
  readonly layerId: string;
}
